// Define a convenience method and use it like
// ready(() => {...});
var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

ready(function() {
  /*
  |-----------------------------------------
  | Option Selector
  |-----------------------------------------
  | Works the variant option dropdowns used on the
  | product page template.
  */
  var variant;
  var options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  var variantOptions = document.querySelectorAll(".js--variant-option");
  variantOptions.forEach(function(el) {
    el.addEventListener("change", function(event) {
      variantOptions.forEach(function(opt) {
        var optionName = opt.getAttribute("name");
        var optionPos = parseInt(optionName.replace("option", ""));
        var optionValue = opt.value;
        options[optionPos] = optionValue;
      });

      variants.filter(function(v) {
        if (v.option1 == options[1] && v.option2 == options[2] && v.option3 == options[3]) {
          variant = v;
          // console.log(v);

          // Update variant id and prices
          var variantPrice = (v.price / 100).toFixed(2);
          document.querySelector("input#js--variant-id").value = v.id;
          document.querySelectorAll(".js--variant-price").forEach(function(el) {
            el.innerText = `£${variantPrice}`;
          });

          if (v.compare_at_price > v.price) {
            var variantCompareAtPrice = (v.compare_at_price / 100).toFixed(2);
            document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
              el.innerText = `Was £${variantCompareAtPrice}`;
            });
          } else {
            document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
              el.innerText = "";
            });
          }

          // Disable the buy button if product is unavailable
          if (v.available === false) {
            document.querySelector("#js--addtocart").disabled = true;
            document.querySelector("#js--addtocart").innerText = "Unavailable";
          } else {
            document.querySelector("#js--addtocart").disabled = false;
            document.querySelector("#js--addtocart").innerText = "Add to basket";
          }

          // Update image
          var imageId = v.featured_image.id;
          var imageIndex = document
            .querySelector('.product-image-item[data-imageid="' + imageId + '"]')
            .getAttribute("data-index");
          var sliderContainer = document.querySelector(".product-images-component");
          goToImage(imageIndex, sliderContainer);

          // Append the variant ID as a url parameter
          if (v != undefined) {
            if (historyState()) {
              window.history.replaceState({}, document.title, "?variant=" + v.id);
            }
          }
        }
      });
    });
  });

  /*
  |-----------------------------------------
  | Forgot Password
  |-----------------------------------------
  | Toggles the forgot your password form.
  */
  document.querySelectorAll(".js--forgot-password").forEach(function(el) {
    el.addEventListener("click", function(event) {
      document.querySelector("#js--login-form").classList.add("hide");
      document.querySelector("#js--forgot-password").classList.remove("hide");
    });
  });

  document.querySelectorAll(".js--login-form").forEach(function(el) {
    el.addEventListener("click", function(event) {
      document.querySelector("#js--login-form").classList.remove("hide");
      document.querySelector("#js--forgot-password").classList.add("hide");
    });
  });

  if (window.location.hash == "#recover") {
    document.querySelector(".js--forgot-password").click();
  }
});

/*
|-----------------------------------------
| History State
|-----------------------------------------
| Check if window.history is supported
*/
var historyState = function() {
  return window.history && window.history.replaceState;
};

/*
|-----------------------------------------
| Toggle Menu
|-----------------------------------------
| Toggles mobile menu.
*/
function toggleMenu() {
  document.body.classList.toggle("nav-open");
  if (document.body.classList.contains("nav-open")) {
    document.querySelectorAll("li.dropdown > a").forEach(function(el) {
      el.addEventListener("click", function(e) {
        el.parentElement.querySelector("ul").classList.toggle("open");
        e.preventDefault();
        return false;
      });
    });
  }
}

/*
|-----------------------------------------
| Mobile Footer
|-----------------------------------------
| Tab the footer for mobiles.
*/
function mobileFooter() {
  if (window.innerWidth <= 767) {
    const footer = document.querySelector(".js--footer-columns");
    let footerCols = footer.querySelectorAll(".js--footer-column");
    footerCols.forEach(function(el) {
      let heading = el.querySelector("h4");
      let title = heading.innerText;
      let content = el.querySelector("ul").innerHTML;
      let html = `
        <details>
          <summary class="h16px green">${title}</summary>
          <div class="">
            <ul>
              ${content}
            </ul>
          </div>
        </details>
      `;
      el.innerHTML = html;
    });
  }
}
mobileFooter();

/*
 * GIFT WRAP OPTION
 * Manages the gift wrap option in the cart.
 */
function runGiftWrap() {
  var $this = event.target;
  var lineItemTitle = $this.getAttribute("data-item-title");
  var lineItemKey = $this.value;
  var $parent = $this.closest('.gift-wrap-option');
  var giftWrapType = $parent.querySelector('.js--gift-wrap-type').value;
  if ($this.checked == true) {
    addGiftWrap(lineItemTitle, lineItemKey, giftWrapType);
  } else {
    removeGiftWrap(lineItemKey);
  }
}

/*
|-----------------------------------------
| Add Gift Wrap Item
|-----------------------------------------
| Adds gift wrap product to cart.
|
| @param lineItemTitle - Product title of the cart line item
| @param lineItemKey (string) - Cart line item key
| @param giftWrapType (string) - Type of gift wrap
*/
function addGiftWrap(lineItemTitle, lineItemKey, giftWrapType = "Plain") {
  var data = {
    items: [{
      id: giftWrap.id,
      quantity: 1,
      properties: {
        Item: lineItemTitle,
        Style: giftWrapType,
        _id: lineItemKey,
      },
    }, ],
  };

  fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((update) => {
      fetch("/cart.json")
        .then((response) => response.json())
        .then((cart) => {
          document.querySelector(".js--cart-subtotal").textContent = moneyWithCurrency(cart.total_price / 100);
        });
    });
}

/*
|-----------------------------------------
| Remove Gift Wrap Item
|-----------------------------------------
| Removes gift wrap item from the cart by
| setting its quantity to 0.
|
| @param lineItemKey (string) - Cart line item key
*/
function removeGiftWrap(lineItemKey) {
  fetch("/cart.json")
    .then((response) => response.json())
    .then((cart) => {
      var item = cart.items.filter(function(item) {
        if (item.properties) {
          if (item.properties["_id"] == lineItemKey) {
            data = {
              id: item.key,
              quantity: 0,
            };
            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              })
              .then((response) => response.json())
              .then((cart) => {
                document.querySelector(".js--cart-subtotal").textContent = moneyWithCurrency(cart.total_price / 100);
              });
          }
        }
      });
    });
}

/*
|-----------------------------------------
| Format Money
|-----------------------------------------
| Formats the passed value as money with
| currency symbol.
*/
function moneyWithCurrency(value) {
  if (value != undefined) {
    var $string = value.toLocaleString("en-GB", { style: "currency", currency: "GBP" });
    return $string;
  }
}

// END